<template>
  <div class="content">
    <!-- 朋友圈 -->
    <div v-if="oPyqData.pyqText && oPyqData.moments_pics.length !== 0">
      <div class="pyq-text">{{ oPyqData.pyqText }}</div>
      <div
        v-for="(item, index) in oPyqData.moments_pics"
        :key="index"
        class="pyq-img"
      >
        <img :src="item.material_file" alt="" />
      </div>
    </div>
    <!-- 视频 -->
    <div v-if="sVideoUrl" class="video-wrap">
      <video
        preload="auto"
        ref="myvideo"
        controls="controls"
        muted
        autoplay="autoplay"
        x5-video-player-type="h5"
        playsinline="true"
        webkit-playsinline="true"
        x-webkit-airplay="true"
        x5-video-orientation="portraint"
        x5-video-player-fullscreen="true"
        loop="loop"
        :src="sVideoUrl"
      ></video>
    </div>
    <!-- 图文 -->
    <div v-html="sHtml"></div>
    <div class="recommend">
      <div class="recommend-title">更多推荐</div>
      <div class="recommend-list">
        <div v-for="(item, index) in arrRecommendList" :key="index">
          <div
            class="multigraph"
            v-if="item.type != 3"
            @click="goNavto(item.materal)"
          >
            <div class="multigraph-title">
              <div class="text">{{ item.title }}</div>
              <div class="bottom">
                <div>{{ item.type_title }}</div>
                <div class="hot">
                  <img src="@/assets/images/ant/details/hot.png" alt="" />
                  <div>{{ item.read_num }}</div>
                </div>
              </div>
            </div>
            <div class="multigraph-cover">
              <img :src="item.pic" alt="" />
            </div>
          </div>
          <div
            class="video"
            v-if="item.type == 3"
            @click="goNavto(item.materal)"
          >
            <div class="video-title">{{ item.keywords }}</div>
            <div class="video-content">
              <img :src="item.pic" alt="" />
            </div>
            <div class="bottom">
              <div>{{ item.type_title }}</div>
              <div class="hot">
                <img src="@/assets/images/ant/details/hot.png" alt="" />
                <div>{{ item.read_num }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {requestAesPost5} from '@/libsV2/requestAes.js'
export default {
  data() {
    return {
      sHtml: "",
      oDetailData: {},
      arrRecommendList: [],
      sVideoUrl: "",
      oPyqData: {},
    };
  },
  created() {
    let that = this;
    $init(() => {
      let materal = that.$route.query.materal;
      this.getContentItems(materal);
    });
  },
  methods: {
    goNavto(materal) {
      // document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.oPyqData = {};
      this.$router.replace({
        path: `/contentdetails/index?materal=${materal}`,
      });
      this.getContentItems(materal);
    },
    getContentItems(materal) {
      let that = this;
      this.$store.commit("loadSwitch", true);
      requestAesPost5('shop/goods/contentItems',{ materialid: materal }).then((res) => {
        // console.log("_>>>>>>>>>>", res);
        let resultData = res.data.data.result.info.model;
        let arrRecommendList = res.result.recommend;
        this.$store.commit("loadSwitch", false);
        arrRecommendList.forEach((item) => {
          switch (item.type) {
            case 1:
              item.type_title = "图文";
              break;
            case 2:
              item.type_title = "图片";
              break;
            case 3:
              item.type_title = "视频";
              break;
            case 4:
              item.type_title = "外链";
              break;
            case 5:
              item.type_title = "公众号";
              break;
            case 6:
              item.type_title = "朋友圈";
              break;
            case 7:
              item.type_title = "音频";
          }
        });
        switch (resultData.type) {
          case 1:
            var sHtml = resultData.content.replace(
              /\<img/gi,
              '<img style="width:100% !important;"'
            );
            break;
          case 2:
            var sHtml =
              "<img src=" +
              "'" +
              resultData.url +
              "'" +
              " style='width:100% !important;height:auto;'/>";
            break;
          case 3:
            that.sVideoUrl = resultData.content;
            break;
          case 4:
            window.location.href = resultData.url; // 外链
            break;
          case 5:
            var sHtml = resultData.content.replace(
              /\<img/gi,
              '<img style="width:100% !important;"'
            );
            break;
          case 6:
            let oPyqData = {
              moments_pics: resultData.moments_pics,
              pyqText: resultData.moments_text,
            };
            that.oPyqData = oPyqData;
            break;
          case 7:
            var sHtml = "<p>暂时不支持音频播放</p>"; // 音频
        }
        that.sHtml = sHtml;
        that.oDetailData = resultData;
        that.arrRecommendList = arrRecommendList;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  background-color: #fff;
  min-height: 100vh;
}
.pyq-text {
  width: 100%;
  height: auto;
  padding: 30px;
  font-size: 28px;
  overflow: hidden;
}
.pyq-img {
  img {
    width: 100%;
  }
}
.video-wrap {
  video {
    width: 100%;
  }
}
.recommend {
  margin-top: 30px;
  padding: 0px 30px;
  box-sizing: border-box;
  .recommend-title {
    height: 80px;
    line-height: 80px;
    font-weight: bold;
    font-size: 30px;
    color: rgba(33, 51, 102, 1);
  }
}
.multigraph {
  display: flex;
  padding: 30px 0px;
  box-sizing: border-box;
  border-top: 1px solid #f7f8fa;
  .multigraph-title {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .text {
      font-size: 30px;
      font-weight: bold;
      text-align: justify;
    }
    .bottom {
      color: #a3a4a6;
      font-size: 24px;
      padding: 5px 0px;
      box-sizing: border-box;
      display: flex;
      .hot {
        display: flex;
        align-items: center;
        margin-left: 20px;
        img {
          margin-right: 8px;
          width: 35px;
          height: 35px;
        }
      }
    }
  }
  .multigraph-cover {
    margin-left: 30px;
    flex-shrink: 0;
    img {
      width: 184px;
      height: 184px;
      border-radius: 12px;
    }
  }
}
.video {
  padding: 30px 0px;
  box-sizing: border-box;
  border-top: 1px solid #f7f8fa;
  .video-title {
    font-size: 30px;
    font-weight: bold;
  }
  .video-content {
    margin-top: 20px;
    img {
      width: 100%;
      // height: 420px;
      border-radius: 5px;
    }
  }
  .bottom {
    color: #a3a4a6;
    font-size: 24px;
    padding: 5px 0px;
    box-sizing: border-box;
    display: flex;
    .hot {
      display: flex;
      align-items: center;
      margin-left: 20px;
      img {
        margin-right: 8px;
        width: 35px;
        height: 35px;
      }
    }
  }
}
</style>